// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal__close{background-color:transparent;border:0;cursor:pointer;display:block;height:20px;opacity:.5;padding:0;position:absolute;right:10px;top:10px;transition:opacity .2s;width:20px}.modal__close:hover{opacity:1}.modal__close:after,.modal__close:before{background-color:#fff;content:\"\";height:19px;left:50%;position:absolute;top:0;width:2px}.modal__close:before{transform:rotate(45deg)}.modal__close:after{transform:rotate(-45deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
